import { type FC } from 'react';
import { useBoostFirebaseEvents } from '@common/hooks/boost-firebase-events';
import { type PlantType } from '@common/types/common';
import { type FactoryTypeText } from '@common/types/factory';
import { type PlantTypeText } from '@common/types/plant';
import { type ResourceTypeText } from '@common/types/resource';
import { BoostFirebaseEventsContext } from '@context/BoostFirebaseEventContext';
import {
  selectActiveBoostForWorkshop,
  selectAdsBoostForWorkshop,
  selectBoostX5ForWorkshop,
  selectBoostX10ForWorkshop,
  selectFreeBoostForWorkshop,
  selectPaidBoostForWorkshop,
  selectTotalWorkshopBoostById,
  selectVipBoostForWorkshop,
  selectWorkshopList,
} from '@redux/selectors/workshopSelectors';
import { useAppSelector } from '@redux/store';

import { type GoodsType } from '@/common/types/goods';

import { BoostCardList } from './BoostCardList/BoostCardList';

interface BoostWorkshopProps {
  plant: PlantTypeText | ResourceTypeText | FactoryTypeText;
  plantType: PlantType;
  plantId: string;
  item: PlantTypeText | ResourceTypeText | GoodsType;
  level: number;
}

const BoostWorkshop: FC<BoostWorkshopProps> = ({
  plantId,
  plant,
  plantType,
  level,
  item,
}) => {
  const freeBoost = useAppSelector((state) =>
    selectFreeBoostForWorkshop(state, plantId),
  );
  const adsBoost = useAppSelector((state) =>
    selectAdsBoostForWorkshop(state, plantId),
  );
  const vipBoost = useAppSelector((state) =>
    selectVipBoostForWorkshop(state, plantId),
  );
  const paidBoost = useAppSelector((state) =>
    selectPaidBoostForWorkshop(state, plantId),
  );
  const boostX5 = useAppSelector((state) =>
    selectBoostX5ForWorkshop(state, plantId),
  );
  const boostX10 = useAppSelector((state) =>
    selectBoostX10ForWorkshop(state, plantId),
  );
  const totalBoost = useAppSelector((state) =>
    selectTotalWorkshopBoostById(state, plantId),
  );
  const workshopList = useAppSelector(selectWorkshopList);
  const activeBoost = useAppSelector(selectActiveBoostForWorkshop);
  const events = useBoostFirebaseEvents(
    { id: plantId, level, name: plant },
    activeBoost,
    workshopList,
  );

  return (
    <BoostFirebaseEventsContext.Provider value={events}>
      <BoostCardList
        plant={plant}
        item={item}
        plantId={plantId}
        plantType={plantType}
        forAllPlantlist={[freeBoost, vipBoost]}
        forCurrentPlantList={[adsBoost, paidBoost, boostX5, boostX10]}
        totalBoost={totalBoost}
        level={level}
      />
    </BoostFirebaseEventsContext.Provider>
  );
};

export { BoostWorkshop };
